import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import Logo from "../elements/logo/Logo";
import LoginForm from "./LoginForm";
import LoginConfirmForm from "./LoginConfirmForm";
import axios from "axios";
import Cookies from "js-cookie";
import Notification from "../elements/notification/Notification";
import GoogleForm from "./GoogleForm";

import { StyledLoginFormHead, StyledLoginFormWrapper, StyledLoginWrapper, StyleFormTitle } from "./styledLogin";
import { DEFAULT_LANGUAGE, STANDARD_ERRORS_WAY, SUPPORTED_LANGUAGES } from "../../utils/consts";
import { useTranslation } from "react-i18next";
import { parseAxiosError } from "../../utils/response";

const LoginContainer = ({ selectedLanguage = SUPPORTED_LANGUAGES[DEFAULT_LANGUAGE].url }) => {
  const [error, setError] = useState({});
  const { t } = useTranslation("loginPage")

  const [authData, setAuthData] = useState({
    responseGoogleToken: null,
    authConfig: null
  });

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const handleSubmit = (data) => {
    data.preventDefault();
    axios.post("/api", { "2fa": data.target.twofa.value }, authData.authConfig).then(response => {
      Cookies.set("token", response.data.data.attributes.token);
      if (Cookies.get("token")) {
        window.location.replace(`/${selectedLanguage.replace("/", "")}`);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledLoginWrapper>
        <Helmet>
          <title>{t("loginMetaTitle")} • eXsoft.io</title>
        </Helmet>
        <Logo className="logo" />
        <StyledLoginFormWrapper>
          {!authData.authConfig && !authData.responseGoogleToken ?
            <React.Fragment>
              <StyledLoginFormHead>
                <StyleFormTitle as="h2">
                  {t("loginTitle")}
                </StyleFormTitle>
              </StyledLoginFormHead>
              <GoogleForm
                authData={authData}
                setAuthData={setAuthData}
                error={error}
                notification={notification}
                setNotification={setNotification}
                t={t}
              />
              <LoginForm
                authData={authData}
                setAuthData={setAuthData}
                error={error}
                notification={notification}
                setNotification={setNotification}
                t={t}
              />
            </React.Fragment>
            :
            <LoginConfirmForm
              handleSubmit={handleSubmit}
              error={error}
              t={t}
            />}
        </StyledLoginFormWrapper>
      </StyledLoginWrapper>
    </>
  );
};

export default LoginContainer;